export const createEmptyDiscountEntry = () => ({
    from: 1,
    to: null,
    discount: 0
});

export const createEmptyDiscount = () => ({
    id: null,
    title: "",
    keyIds: [],
    entries: [createEmptyDiscountEntry()]
});

export const deriveDiscountEntries = (entries) => {
    const sourceEntries = entries && entries.length > 0 ? entries : [createEmptyDiscountEntry()];
    let nextFrom = 1;

    return sourceEntries.map((entry, index) => {
        const lastEntry = index === sourceEntries.length - 1;
        const updatedEntry = {
            ...entry,
            from: nextFrom,
            to: lastEntry ? null : entry.to
        };

        const numericTo = parsePositiveInteger(updatedEntry.to);
        nextFrom = numericTo === null ? "" : numericTo + 1;

        return updatedEntry;
    });
};

export const prepareDiscountForSubmit = (discountInfo) => ({
    ...discountInfo,
    title: discountInfo.title.trim(),
    keyIds: discountInfo.keyIds || [],
    entries: deriveDiscountEntries(discountInfo.entries).map((entry, index, entries) => ({
        from: Number(entry.from),
        to: index === entries.length - 1 ? null : Number(entry.to),
        discount: Number(entry.discount)
    }))
});

export const validateDiscountInfo = (discountInfo) => {
    if (!discountInfo.title || discountInfo.title.trim() === "") {
        return "Bitte geben Sie einen Titel ein.";
    }

    const entries = deriveDiscountEntries(discountInfo.entries);
    if (entries.length === 0) {
        return "Bitte geben Sie mindestens eine Rabattstaffel ein.";
    }

    for (let index = 0; index < entries.length; index++) {
        const entry = entries[index];
        const lastEntry = index === entries.length - 1;
        const from = parsePositiveInteger(entry.from);
        const to = parsePositiveInteger(entry.to);
        const discount = parseDiscount(entry.discount);

        if (from === null) {
            return "Bitte prüfen Sie die Rabattstaffel.";
        }
        if (!lastEntry && to === null) {
            return "Bitte geben Sie für jede geschlossene Staffel ein Bis-Feld ein.";
        }
        if (!lastEntry && to < from) {
            return "Das Bis-Feld darf nicht kleiner als das Von-Feld sein.";
        }
        if (discount === null || discount < 0 || discount > 100) {
            return "Der Rabatt muss zwischen 0 und 100 liegen.";
        }
    }

    return null;
};

export const formatDiscountEntries = (entries) => {
    if (!entries || entries.length === 0) {
        return "-";
    }

    return deriveDiscountEntries(entries)
        .map(entry => entry.to == null
            ? `ab ${entry.from}: ${formatDiscount(entry.discount)} %`
            : `${entry.from}-${entry.to}: ${formatDiscount(entry.discount)} %`
        )
        .join(", ");
};

const parsePositiveInteger = (value) => {
    if (value === null || value === undefined || value === "") {
        return null;
    }

    const parsed = Number(value);
    if (!Number.isInteger(parsed) || parsed < 1) {
        return null;
    }

    return parsed;
};

const parseDiscount = (value) => {
    if (value === null || value === undefined || value === "") {
        return null;
    }

    const parsed = Number(value);
    if (!Number.isFinite(parsed)) {
        return null;
    }

    return parsed;
};

const formatDiscount = (discount) => {
    const parsed = Number(discount);
    if (!Number.isFinite(parsed)) {
        return discount;
    }

    return parsed.toLocaleString("de-AT", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    });
};
